import {getRequestV2SubmissionStatusOptionDatas} from 'search/filters/RequestV2SubmissionStatusFilterForm';
import {OptionData} from 'ui-library/menus/MenuConstants';

import {getConnectionGatewayMenuOptionDatas} from './filters/ConnectionGatewayFilterForm';
import {getInventoryValidationErrorLabelMenuOptionDatas} from './filters/InventoryValidationErrorLabelFilterForm';
import {getPublishingStatusOptionDatas} from './filters/PublishingStatusFilterForm';
import {getReviewLifecycleMenuOptionDatas} from './filters/ReviewLifecycleFilterForm';
import {getSchemaValidationErrorLabelMenuOptionDatas} from './filters/SchemaValidationErrorLabelFilterForm';
import {getTestStatusOptionDatas} from './filters/TestStatusFilterForm';
import {FilterKey} from './SearchConstants';

export type StandardEnumFilterConfig = {
  [key in FilterKey]: {
    isSearchable: boolean;
    getOptionDatas: () => Promise<Array<OptionData>>;
  };
};

// Ideally these would be part of `FILTERS` in SearchConstants.ts, but it is pretty common for the logic to
// generate enum OptionDatas to have depedendencies that ultimately import SearchConstants, which would
// create a circular dependency. We should decompose SearchConstants into smaller files at some point, but
// for now this is in a separate file as a compromise.
export const FILTER_ENUM_CONFIGS: Partial<StandardEnumFilterConfig> = {
  [FilterKey.CONNECTION_GATEWAY]: {
    isSearchable: false,
    getOptionDatas: getConnectionGatewayMenuOptionDatas,
  },
  [FilterKey.INVENTORY_VALIDATION_ERROR_LABEL]: {
    isSearchable: false,
    getOptionDatas: getInventoryValidationErrorLabelMenuOptionDatas,
  },
  [FilterKey.PUBLISHING_STATUS]: {
    isSearchable: false,
    getOptionDatas: getPublishingStatusOptionDatas,
  },
  [FilterKey.REQUEST_V2_SUBMISSION_STATUS]: {
    isSearchable: false,
    getOptionDatas: getRequestV2SubmissionStatusOptionDatas,
  },
  [FilterKey.REVIEW_LIFECYCLE]: {
    isSearchable: true,
    getOptionDatas: getReviewLifecycleMenuOptionDatas,
  },
  [FilterKey.SCHEMA_VALIDATION_ERROR_LABEL]: {
    isSearchable: false,
    getOptionDatas: getSchemaValidationErrorLabelMenuOptionDatas,
  },
  [FilterKey.TEST_STATUS]: {
    isSearchable: false,
    getOptionDatas: getTestStatusOptionDatas,
  },
};
